
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/google-gemini-ui",
      function () {
        return require("private-next-pages/google-gemini-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/google-gemini-ui"])
      });
    }
  